var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c("div", { staticClass: "onlyForHighScreens" }, [_vm._v(" ")]),
      _vm.$store.getters.isKiosk
        ? [_vm._m(0)]
        : [
            _c(
              "h2",
              {
                staticClass: "text-center mt-7",
                staticStyle: { "margin-bottom": "2px" },
              },
              [
                _vm._v(" Bestellung für "),
                _vm.$store.getters.selectedOrderModeByUser === "inhouse" &&
                _vm.plannedAnkunftszeit?.utc
                  ? _c("span", [
                      _vm._m(1),
                      _vm._v(
                        " mit geplanter Ankunftszeit am " +
                          _vm._s(_vm.plannedAnkunftszeit.dayOfMonth) +
                          "." +
                          _vm._s(_vm.plannedAnkunftszeit.month) +
                          ", "
                      ),
                      _c("span", { staticClass: "text-no-wrap" }, [
                        _vm._v(_vm._s(_vm.plannedAnkunftszeit.time) + " Uhr"),
                      ]),
                    ])
                  : _c("span", [
                      _vm.$store.state.orderArea
                        ? _c("span", { staticClass: "text-no-wrap" }, [
                            _vm._v(_vm._s(_vm.$store.state.orderArea)),
                          ])
                        : _c("span", { staticClass: "text-no-wrap" }, [
                            _vm._v("Tisch " + _vm._s(_vm.$store.getters.table)),
                          ]),
                    ]),
              ]
            ),
          ],
      _c("div", { staticClass: "text-center" }, [
        _c("h4", { class: { "mb-6": !_vm.$store.getters.isKiosk } }, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
          ]),
        ]),
        _vm.$store.getters.isKiosk
          ? _c("h4", { staticClass: "mb-6" }, [
              _vm._v(" Zahlung an der Kasse "),
            ])
          : _vm._e(),
      ]),
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "kioskCheckoutContainer" },
          [
            _c(
              "v-stepper",
              {
                staticClass: "vvd orderform",
                attrs: { vertical: "", id: "stepper" },
                model: {
                  value: _vm.currentStep,
                  callback: function ($$v) {
                    _vm.currentStep = $$v
                  },
                  expression: "currentStep",
                },
              },
              [
                _c(
                  "v-stepper-step",
                  {
                    attrs: { complete: _vm.currentStep > 1, step: "1" },
                    nativeOn: {
                      "&click": function ($event) {
                        _vm.currentStep = 1
                      },
                    },
                  },
                  [
                    _vm.$store.getters.isKiosk
                      ? _c("div", { staticClass: "nice-title titleFont" }, [
                          _vm._v(
                            "Optional kannst du deinen Namen für die Abholung eingeben "
                          ),
                        ])
                      : _c("div", { staticClass: "nice-title small" }, [
                          _vm._v("Deine Bestelldaten"),
                        ]),
                  ]
                ),
                _c("v-stepper-content", { attrs: { step: "1" } }, [
                  _vm.usecase.length > 0
                    ? _c(
                        "div",
                        { attrs: { id: "checkData" } },
                        [
                          _c(
                            "div",
                            { staticClass: "bestelldaten pt-1" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "checkoutFormInhouse",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      outlined: "",
                                      label:
                                        (_vm.selfServiceEnabled ||
                                          _vm.preOrder) &&
                                        !_vm.$store.getters.isKiosk
                                          ? "Name*"
                                          : "Name (optional)",
                                      rules: _vm.nameRules,
                                      placeholder: "Name",
                                      illed: "",
                                      "hide-details": "",
                                    },
                                    on: {
                                      focus: _vm.nameFocus,
                                      blur: _vm.unhideToolbar,
                                    },
                                    model: {
                                      value: _vm.name,
                                      callback: function ($$v) {
                                        _vm.name = $$v
                                      },
                                      expression: "name",
                                    },
                                  }),
                                  _vm.selfServiceEnabled &&
                                  !_vm.$store.getters.isKiosk
                                    ? _c("v-text-field", {
                                        ref: "phone",
                                        attrs: {
                                          outlined: "",
                                          rules: _vm.phoneRules,
                                          label: "Mobilnummer*",
                                          placeholder: "",
                                          illed: "",
                                        },
                                        on: {
                                          keydown: function ($event) {
                                            return _vm.phoneKeydown($event)
                                          },
                                        },
                                        model: {
                                          value: _vm.phone,
                                          callback: function ($$v) {
                                            _vm.phone = $$v
                                          },
                                          expression: "phone",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.$store.state.enableOrderNote
                            ? [
                                _c("h4", { staticClass: "mt-4" }, [
                                  _vm._v("Hinweise zur Bestellung"),
                                ]),
                                _c("v-text-field", {
                                  staticClass: "nolabel",
                                  attrs: {
                                    outlined: "",
                                    "hide-details": "",
                                    clearable: "",
                                    illed: "",
                                  },
                                  on: { focus: _vm.hinweisFocus },
                                  model: {
                                    value: _vm.note,
                                    callback: function ($$v) {
                                      _vm.note = $$v
                                    },
                                    expression: "note",
                                  },
                                }),
                              ]
                            : _vm._e(),
                          !_vm.$store.getters.isKiosk
                            ? _c(
                                "div",
                                { staticClass: "mt-4" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "mt-3 orderBtn wallet-width text-none rounded100",
                                          attrs: { color: "green", dark: "" },
                                          nativeOn: {
                                            "&click": function ($event) {
                                              return _vm.doOrder.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " Zahlungspflichtig bestellen "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("orderconsent"),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("div", { staticClass: "mt-3" }, [
                            _vm.$store.getters.isKiosk
                              ? _c("span", [
                                  _vm._v(
                                    "Die Bezahlung erfolgt an der Kasse mittels deiner Bestellnummer!"
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v("Die Bezahlung erfolgt beim Kellner!"),
                                ]),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm.$store.getters.isKiosk
          ? _c("div", { staticClass: "mt-4 text-center" }, [
              _c(
                "div",
                [
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "mt-3 orderBtn wallet-width text-none rounded100",
                      attrs: { color: "green", dark: "" },
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.doOrder.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" Bestätige deine Bestellung ")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      !_vm.$store.getters.isKiosk ? [_c("ssl-seal")] : _vm._e(),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: { click: _vm.cancelOrder },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
      _vm.showKeyboard
        ? _c("div", { staticClass: "fixedVirtualKeyboard" }, [
            _c(
              "div",
              { staticClass: "superCenter" },
              [
                _c("VirtualKeyboard", {
                  attrs: { label: _vm.keyboardLabel },
                  on: {
                    enter: _vm.keyboardEnter,
                    close: function ($event) {
                      _vm.showKeyboard = false
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass: "text-center mt-7",
        staticStyle: { "margin-bottom": "2px" },
      },
      [
        _c("span", [_vm._v(" ")]),
        _c("br"),
        _c("span", [_vm._v("Bestellung abschließen")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "text-no-wrap" }, [
      _c("br"),
      _vm._v("🍽️ Zum Hier essen"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }